import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { UserNotificationCounter } from '../user-notification-counter';

export class UserNotificationCounterBuilder {
  static fromJson(json) {
    return (json)
      ? new UserNotificationCounter(
        parseNumber(json.counter),
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(UserNotificationCounterBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/user-notification-counter.builder.ts